import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  assistanceData: null,
};

const slice = createSlice({
  name: "assistance",
  initialState: initialState,
  reducers: {
    getAssistanceData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.assistanceData = null;
    },
    getAssistanceDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.assistanceData = action.payload;
    },
    getAssistanceDataError: (state, action) => {
      state.error = action.payload;
      state.assistanceData = null;
      state.loading = false;
    },
    assistanceResetState: () => initialState,
  },
});

export const {
  getAssistanceData,
  getAssistanceDataSuccess,
  getAssistanceDataError,
  assistanceResetState,
} = slice.actions;

export default slice.reducer;
